import React from 'react';
import './PageSkeleton.css';

const SkeletonBox = ({ width = '100%', height = '16px', radius = '8px', className = '' }) => (
  <div className={`skeleton-box ${className}`} style={{ width, height, borderRadius: radius }} />
);

const PageSkeleton = () => {
  return (
    <div className="page-skeleton">

      {/* Top header: title + buttons */}
      <div className="sk-top-header">
        <div className="sk-title-group">
          <SkeletonBox width="200px" height="22px" />
          <SkeletonBox width="320px" height="14px" />
        </div>
        <div className="sk-btn-group">
          <SkeletonBox width="100px" height="38px" radius="42px" />
          <SkeletonBox width="120px" height="38px" radius="42px" />
        </div>
      </div>

      {/* Stats boxes */}
      <div className="sk-boxes">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="sk-stat-card">
            <SkeletonBox width="48px" height="48px" radius="8px" />
            <div className="sk-stat-text">
              <SkeletonBox width="90px" height="13px" />
              <SkeletonBox width="60px" height="20px" />
            </div>
          </div>
        ))}
      </div>

      {/* Table area */}
      <div className="sk-table-wrap">

        {/* Search / filter bar */}
        <div className="sk-filter-bar">
          <SkeletonBox width="240px" height="38px" radius="42px" />
          <div className="sk-btn-group">
            <SkeletonBox width="90px" height="38px" radius="42px" />
            <SkeletonBox width="90px" height="38px" radius="42px" />
          </div>
        </div>

        {/* Table header */}
        <div className="sk-table-header">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="14px" radius="6px" />
          ))}
        </div>

        {/* Table rows */}
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="sk-table-row">
            {Array.from({ length: 6 }).map((_, j) => (
              <SkeletonBox key={j} width={j === 0 ? '60%' : '80%'} height="14px" radius="6px" />
            ))}
          </div>
        ))}
      </div>

    </div>
  );
};

export default PageSkeleton;
